export const general = {
  company: "Εταιρεία",
  login: "Σύνδεση",
  logout: "Αποσύνδεση",
  profile: "Προφίλ",
  language: "Γλώσσα",
  search: "Αναζήτηση",
  cancel: "Ακύρωση",
  add: "Προσθήκη",
  firstName: "Όνομα",
  lastName: "Επώνυμο",
  email: "Email",
  role: "Ρόλος",
  image: "Εικόνα",
  application: "Εφαρμογή",
  valid: "Έγκυρο",
  address: "Διεύθυνση",
  city: "Πόλη",
  postalCode: "Ταχυδρομικός Κώδικας",
  country: "Χώρα",
  phone: "Τηλέφωνο",
  logo: "Λογότυπο",
  backOffice: "Back Office",
  home: "Αρχική",
  homePage: "Αρχική Σελίδα",
  ourPartners: "Οι Συνεργάτες μας",
  suppliers: "Προμηθευτές",
  customers: "Πελάτες",
  partners: "Συνεργάτες",
  workWithUs: "Συνεργαστείτε μαζί μας",
  uploadFile: "Ανέβασμα Αρχείου",
  uploadImage: "Ανέβασμα Εικόνας",
  uploadDocument: "Ανέβασμα Εγγράφου",
  setToDefaultImage: "Ορισμός σε προεπιλεγμένη εικόνα",
  upload: "Ανέβασμα",
  uploadImages: "Ανέβασμα Εικόνων",
  uploadDocuments: "Ανέβασμα Εγγράφων",
  noImages: "Χωρίς εικόνες",
  noDocuments: "Χωρίς έγγραφα",
  cart: "Καλάθι",
  yes: "Ναι",
  no: "Όχι",
  myOrders: "Οι Παραγγελίες μου",
  deleteImage: "Διαγραφή Εικόνας",
  undoDeleteImage: "Αναίρεση Διαγραφής Εικόνας",
  orders: "Παραγγελίες",
  account: "Λογαριασμός",
  reset: "Επαναφορά",
  apply: "Εφαρμογή",
  openInDesktop: "Παρακαλώ ανοίξτε από υπολογιστή",
  mainAppLogo: "Κύριο Λογότυπο Εφαρμογής",
  footerLogo: "Λογότυπο Υποσέλιδου",
  appName: "Όνομα Εφαρμογής",
  projectName: "Όνομα Έργου",
  appConfig: "Διαμόρφωση Εφαρμογής",
  appLogoAltText: "Εναλλακτικό Κείμενο Λογοτύπου Εφαρμογής",
  appFooterLogoAltText: "Εναλλακτικό Κείμενο Λογοτύπου Υποσέλιδου",
  footerEuFlagImage: "Εικόνα Ευρωπαϊκής Σημαίας Υποσέλιδου",
  footerEuFlagImageAltText:
    "Εναλλακτικό Κείμενο Εικόνας Ευρωπαϊκής Σημαίας Υποσέλιδου",
  fundedBy:
    "Αυτό το έργο έχει λάβει χρηματοδότηση από το πρόγραμμα Horizon Europe της Ευρωπαϊκής Ένωσης στο πλαίσιο της συμφωνίας επιχορήγησης αριθ.",
  projectRegistrationNumber: "Αριθμός Εγγραφής Έργου",
  footerCentralImageContent: "Περιεχόμενο Κεντρικής Εικόνας Υποσέλιδου",
  basicData: "Βασικά Δεδομένα",
  footerData: "Δεδομένα Υποσέλιδου",
  socialMedia: "Κοινωνικά Δίκτυα",
  footerCentralImageSrc: "Πηγή Κεντρικής Εικόνας Υποσέλιδου",
  hasCart: "Διαθέτει Καλάθι",
  hasMultiLanguage: "Διαθέτει Πολλαπλές Γλώσσες",
  basicInfo: "Βασικές Πληροφορίες",
  companyName: "Όνομα Εταιρείας",
  edit: "Επεξεργασία",
  tabTitle: "Τίτλος Καρτέλας",
  favicon: "Εικονίδιο Καρτέλας (μέγεθος: 64x64)",
  userRole: "Ρόλος Χρήστη",
  userRoles: "Ρόλοι Χρήστη",
  buyer: "Αγοραστής",
  seller: "Πωλητής",
  hybrid: "Υβριδικός",
  myRequests: "Οι Αιτήσεις μου",
  createRequest: "Δημιουργία Αίτησης",
  sortBy: "Ταξινόμηση",
  priceAscending: "Τιμή Αύξουσα",
  priceDescending: "Τιμή Φθίνουσα",
  resetSorting: "Επαναφορά Ταξινόμησης",
  landingPageBackgroundImageSrc:
    "Πηγή Εικόνας Φόντου Αρχικής Σελίδας (Ελάχιστο πλάτος: 1920)",
  basicConfiguration: "Βασικές Ρυθμίσεις",
  syncWithSurplex: "Συγχρονισμός με Surplex",
  sync: "Συγχρονισμός",
  created: "Δημιουργήθηκε",
  updated: "Ενημερώθηκε",
  submitted: "Υποβλήθηκε",
  active: "Ενεργό",
  userActions: "Ενέργειες Χρήστη",
  uploadFiles: "Ανέβασμα Αρχείων",
  saveAndClose: "Αποθήκευση και Κλείσιμο",
  saveAndContinue: "Αποθήκευση και Συνέχεια",
  exit: "Exit",
  continue: "Συνέχεια",
  closeAndContinue: "Κλείσιμο και Συνέχεια",
  unableToInitializeKeycloak: "Αδυναμία Αρχικοποίησης Keycloak",
  logs: "Καταγραφές",
  getProducts: "Λήψη Προϊόντων",
  deleteProducts: "Διαγραφή Προϊόντων",
  images: "Εικόνες",
  selectedProject: "Επιλεγμένο Έργο",
  about: "Σχετικά",
  aboutPage: "Σελίδα Σχετικά",
  aboutImage: "Εικόνα Σxετικά",
  policyFiles: "Αρχεία Πολιτικής",
  projectLink: "Σύνδεσμος Έργου",
  visitProject: "Επίσκεψη Έργου",
  categories: "Κατηγορίες",
  menu: "Μενού",
  homePageUrl: "Homepage Url",
  saving: "Αποθήκευση",
  loading: "Φόρτωση",
  syncedWith: "Συγχρονίστηκε με",
  errorSyncingWith: "Σφάλμα συγχρονισμού με",
  deletedProducts: "Διαγραφή προϊόντων",
  errorDeletingProducts: "Σφάλμα διαγραφής προϊόντων",
  deleted: "Διαγράφηκε",
  error: "Σφάλμα",
  added: "Προστέθηκαν",
  duration: "Διάρκεια",
  fetched: "Λήφθησαν",
  thisPropertyWillBeDeleted: "Αυτή η ιδιότητα θα διαγραφεί",
  propertyName: "Όνομα Ιδιότητας",
  mainButtonColor: "Χρώμα κύριου κουμπιού",
  mainButtonTextColor: "Χρώμα κειμένου κύριου κουμπιού",
  mainButtonHoverColor: "Χρώμα κύριου κουμπιού όταν περνάει ο δείκτης",
  mainButtonHoverTextColor:
    "Χρώμα κειμένου κύριου κουμπιού όταν περνάει ο δείκτης",
  navbarBackgroundColor: "Χρώμα φόντου γραμμής πλοήγησης",
  navbarTextColor: "Χρώμα κειμένου γραμμής πλοήγησης",
  pageNotFound: "Η σελίδα δεν βρέθηκε",
  goToHome: "Επιστροφή στην αρχική σελίδα",
  back: "Πίσω",
  save: "Αποθήκευση",
  submit: "Υποβολή",
  expand: "Ανάπτυξη",
  collapse: "Σύμπτυξη",
};
